module.exports = __webpack_public_path__ + "media/promo/courses/images/pepper-5d3fe7312455fa9f8d3c9e8749e65aa7.png";